// @ts-nocheck

import { useCallback, useEffect } from 'react';

import { type CustomRouterHistory } from '../../../../createHistory';
import type {
  InitBasketType,
  InitPublicBasketType,
  InitHistoryBasketType,
  FillPrechecksType,
} from '../../types/actions';

type GridsBasketRouteUpdateProps = {
  history: CustomRouterHistory;
  initBasket: InitBasketType;
  initPublicBasket: InitPublicBasketType;
  initHistoryBasket: InitHistoryBasketType;
  fillPrechecks: FillPrechecksType;
  shoudInit: boolean;
  shoudPublicInit: boolean;
  shoudHistoryInit: boolean;
  shouldFillPrechecks: boolean;
  poolId: number;
  selections: Array<string>;
  gridReference: string | null;
  urlPoolTitle: string;
};

const GridsBasketRouteUpdate = ({
  history,
  initBasket: dispatchInitBasket,
  initPublicBasket: dispatchInitPublicBasket,
  initHistoryBasket: dispatchInitHistoryBasket,
  fillPrechecks: dispatchFillPrechecks,
  shoudInit,
  shoudPublicInit,
  shoudHistoryInit,
  shouldFillPrechecks,
  poolId,
  selections,
  gridReference,
  urlPoolTitle,
}: GridsBasketRouteUpdateProps) => {
  const removePrechecksFromUrl = useCallback(() => {
    if (urlPoolTitle) {
      history.replace(urlPoolTitle);
    }
  }, [history, urlPoolTitle]);

  useEffect(() => {
    if (shoudInit) {
      dispatchInitBasket({ poolId, selections });
    }
  }, [dispatchInitBasket, poolId, selections, shoudInit]);

  useEffect(() => {
    if (shoudPublicInit && poolId && gridReference) {
      dispatchInitPublicBasket({ poolId, gridReference });
    }
  }, [dispatchInitPublicBasket, gridReference, poolId, shoudPublicInit]);

  useEffect(() => {
    if (shoudHistoryInit && poolId && gridReference) {
      dispatchInitHistoryBasket({ poolId, gridReference });
    }
  }, [dispatchInitHistoryBasket, gridReference, poolId, shoudHistoryInit]);

  useEffect(() => {
    if (shouldFillPrechecks && poolId && selections) {
      dispatchFillPrechecks({ poolId, selections });
      removePrechecksFromUrl();
    }
  }, [dispatchFillPrechecks, poolId, removePrechecksFromUrl, selections, shouldFillPrechecks]);

  return null;
};

export default GridsBasketRouteUpdate;
